export default {
  api: {
    url: "https://walrus-app-s22bb.ondigitalocean.app/api/v1/",
    baseUrl: "https://walrus-app-s22bb.ondigitalocean.app",
  },
  featureFlags: {
    freeLaunch: true,
  },
  env: "staging",
  log: "debug",
  recaptchaKey: process.env.REACT_APP_RECAPTCHA,
};
